// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

let Types = {};

let fragmentConverter = {};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function localDraftMlsStatus_decode($$enum) {
  if ($$enum === "NotCalled" || $$enum === "OnMlsButAllowed" || $$enum === "Called" || $$enum === "OnMls" || $$enum === "Error" || $$enum === "NotOnMls") {
    return $$enum;
  }
}

let localDraftMlsStatus_fromString = localDraftMlsStatus_decode;

function localGeocodingStatus_decode($$enum) {
  if ($$enum === "NotCalled" || $$enum === "ErrorOutsideChapterBoundaries" || $$enum === "Called" || $$enum === "ErrorDuplicateListing" || $$enum === "Valid" || $$enum === "Error") {
    return $$enum;
  }
}

let localGeocodingStatus_fromString = localGeocodingStatus_decode;

let Utils = {
  localDraftMlsStatus_decode: localDraftMlsStatus_decode,
  localDraftMlsStatus_fromString: localDraftMlsStatus_fromString,
  localGeocodingStatus_decode: localGeocodingStatus_decode,
  localGeocodingStatus_fromString: localGeocodingStatus_fromString
};

let node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PropertyWizardFormRelayEffects_formState",
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "geocodingStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mlsStatus",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "LocalDraftFormState",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
